module.exports = __webpack_public_path__ + "img/home2.a4a4a57f.png";